module.exports = __webpack_public_path__ + "static/media/nuevo_contrato.48aa92c3.svg";